import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { AuthTokenService } from './auth-token.service';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private errorHandlerService: ErrorHandlerService,
    private authTokenService: AuthTokenService
  ) {}

  public loginNoAuthMode(userId: string): Observable<any> {
    return this.authTokenService.getNewTokenNoauth(userId).pipe(
      catchError((error) => {
        this.errorHandlerService.errorHandler(error);
        return throwError(error);
      })
    );
  }

  public loginLdap(userId: string, password: string, captchaToken: string): Observable<any> {
    return this.authTokenService.getNewTokenLdap(userId, password, captchaToken).pipe(
      catchError((error) => {
        this.errorHandlerService.errorHandler(error);
        return throwError(error);
      })
    );
  }
}
